enum StepEnum {
  Placeholder,
  About,
  TechSkills,
  Projects,
  Contact,
}

export { StepEnum }
